import React, { useState, useEffect, useRef, createContext } from "react";
const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [userData, setUserData] = useState({});
    const didMountRef = useRef(true);


   


    useEffect(() => {
     

        
    }, []);

    return (
        <DataContext.Provider value={
            {
                userData, setUserData,
               
            }
        }>
            {children}
        </DataContext.Provider>
    );
};

export default DataContext;